import api from "./api";

export const getProduct = async (params) => {
  return api.get("/products", params, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};
